export default {
  zh: {
    paymentResult: '支付结果',
    noticeInfo: '请您完成付款后，点击下方按钮确认支付完成',
    paymentCompleted: '支付已完成',
    contactUsNotice: '如遇支付问题请联系我们，邮箱地址'
  },
  en: {
    paymentResult: 'Payment Status',
    noticeInfo: 'Please click the button below to confirm the payment once you have finished the payment.',
    paymentCompleted: 'Payment completed',
    contactUsNotice: 'If you have payment problem, please contact customer service via'
  }
}



// WEBPACK FOOTER //
// ./src/components/createdOrder/lang.js